<template>
    <v-card style="" class="pb-3 pt-0 px-2 account-emails">
        <div v-if="emails.length">
            <v-card
                class="pb-4 pt-2 px-3 my-3"
                v-for="(email, index) in emails"
            >
                <v-layout row class="px-3 pb-1 pt-3">
                    <div class="font-weight-medium mr-2 width-200">
                        Date:
                    </div>
                    <div>
                        {{ email.date | time }}
                    </div>
                </v-layout>
                <v-layout row class="px-3 py-1" v-if="email.from">
                    <div class="font-weight-medium mr-2 width-200">
                        From:
                    </div>
                    <div>
                        {{ email.from }}
                    </div>
                </v-layout>
                <v-layout row class="px-3 py-1">
                    <div class="font-weight-medium mr-2 width-200">
                        To:
                    </div>
                    <div>
                        {{ email.to }}
                    </div>
                </v-layout>
                <v-layout row class="px-3 py-1">
                    <div class="font-weight-medium mr-2 width-200">
                        Type:
                    </div>
                    <div>
                        {{ email.type }}
                    </div>
                </v-layout>
                <v-layout row class="px-3 py-1">
                    <div class="font-weight-medium mr-2 width-200">
                        Status:
                    </div>
                    <div>
                        {{ email.status }}
                    </div>
                </v-layout>
                <v-layout v-if="email.text" column class="px-3 py-1">
                    <div class="font-weight-medium width-200 mt-2 mb-1">
                        Text:
                    </div>
                    <v-layout row class="pb-2 ml-0">
                        <div v-if="!email.showText">
                            {{ truncateText(email) }}
                        </div>
                        <button
                            class="view-card-button"
                            @click="email.showText = !email.showText"
                        >
                            {{
                                email.showText
                                    ? "Hide Full Text"
                                    : "Show Full Text"
                            }}
                        </button>
                    </v-layout>
                    <div
                        v-if="email.showText"
                        style="white-space: pre-line !important;"
                    >
                        {{ email.text }}
                    </div>
                </v-layout>
            </v-card>
        </div>
    </v-card>
</template>
<script>
import { formatPhoneNumber, truncate } from "../../utils/helpers.js";
export default {
    props: {
        emails: Array,
    },
    data() {
        return {};
    },
    watch: {},
    async created() {},
    mounted() {},
    beforeDestroy() {},
    computed: {},
    methods: {
        truncateText(email) {
            return truncate(email.text, 50);
        },
    },
};
</script>
<style>
.account-emails {
    background-color: #f1ffdc !important;
    height: 550px;
    overflow-y: auto;
}
</style>
